'use strict';

import GraphQL from './graphql';

export default {

  get () {
    const query = `{
      parties() {
        id
        name
      }
    }`;

    return GraphQL.post(query);
  },
};



// WEBPACK FOOTER //
// ./app/javascript/vue/services/parties.js